import { useTranslation } from "react-i18next";

import { computationOptions } from "#app/computationOptions";
import { useOptimizedMachineTimes } from "#modules/optimizations/view/useOptimizedMachineTimes";
import { useOptimizedMaterialCosts } from "#modules/optimizations/view/useOptimizedMaterialCosts";
import { QuoteRequestLineDto } from "#modules/quoteRequestLines/infra/fetchQuoteRequestLine.api";
import { PriceDisplay } from "#modules/quoteRequestLines/PriceDisplay";
import { computeQuoteRequestLinePrice } from "shared";

type Props = {
  quoteRequestLine: QuoteRequestLineDto;
};

export const UnitEstimatedPriceDisplay = ({ quoteRequestLine }: Props) => {
  const { t } = useTranslation();
  const optimizedMachineTimes = useOptimizedMachineTimes(quoteRequestLine.quoteRequestId);
  const optimizedMaterialCosts = useOptimizedMaterialCosts(quoteRequestLine.quoteRequestId);

  const {
    partCost,
    costs: { partAddedValueProcessesCost },
  } = computeQuoteRequestLinePrice(
    {
      quoteRequestLine,
      optimizedMachineTimes,
      optimizedMaterialCosts,
    },
    computationOptions,
  );

  return (
    <PriceDisplay
      primaryCostLabel={t("qrl.price.estimatedUnitCost")}
      primaryCost={partCost}
      secondaryCostLabel={t("qrl.price.VAT")}
      secondaryCost={partAddedValueProcessesCost}
    />
  );
};
